import Fetch from '@/utils/Fetch';

const getCompany = async () => {
    return await Fetch.get({
        url: '/Company'
    });
};

const getCustomerZoneCompany = async (tenantID: any, customerID: any, api: any) => {
    return await Fetch.get({
        url: '/CustomerZone/Company',
        tenantID: tenantID,
        customerID: customerID,
        apiUrlOverride: api
    });
};

const saveCompany = async (company: any, toast = null) => {
    return await Fetch.put({
        url: '/Company',
        params: company,
        toastCtx: toast
    });
};

const getCurrencies = async () => {
    return await Fetch.get({
        url: `/Company/GetCurrencies`
    });
};

const getCurrencySymbol = async () => {
    const company = await getCompany();
    return company.Currency ? company.Currency.Symbol : '';
};

const getCustomerZoneCurrencySymbol = async (tenantID: any, customerID: any, api: any) => {
    const company = await getCustomerZoneCompany(tenantID, customerID, api);
    return company.Currency ? company.Currency.Symbol : '';
};

export default {
    getCompany,
    getCustomerZoneCompany,
    saveCompany,
    getCurrencies,
    getCurrencySymbol,
    getCustomerZoneCurrencySymbol,
};
